import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import {
  fetchRespondent,
  RespondentApiArgs,
} from '~/App/Modules/Testimonials/Actions/respondentsAction';
import { GetTestimonialRespondentResponse } from '~/types/api/testimonials';

export const queryKeys = {
  all: ['respondent'],
  lists: () => [...queryKeys.all, 'list'] as const,
  details: () => [...queryKeys.all, 'detail'] as const,
  detail: ({ testimonialUuid, respondentUuid }: RespondentApiArgs) =>
    [...queryKeys.details(), testimonialUuid, respondentUuid] as const,
};

export function useTestimonialRespondent(
  args: RespondentApiArgs,
  queryOptions?: UseQueryOptions<GetTestimonialRespondentResponse, AxiosError>
) {
  return useQuery<GetTestimonialRespondentResponse, AxiosError>(
    queryKeys.detail(args),
    () => fetchRespondent(args),
    { ...queryOptions }
  );
}
